export const locale = {
  lang: 'es',
  data: {
    'ALERTS':{
      'OK':'OK'
    },
    'SHEDULE': {
      'TITLE1': 'Registrar fecha de lanzamiento: ',
      'TITLE2': 'Registrar recordatorio: ',
      'TITLE3': 'Registrar cierre: ',
      'ERR01':'Los recordatorios no pueden ser menor a la fecha de lazamiento',
      'ERR02':'Los recordatorios no pueden ser mayor a la fecha de cierre',
      'ERR03':'Los recordatorios deben ser durante los 21 días de la encuesta',
      'ERR04':'Solo puedes tener 3 recordatorios',
      'ERR05':'La fecha no puede ser menor a la actual',
      'ERR06':'Ya has enviado un correo el día de hoy',
      'SUC01':'Recordatorio registrado',
      'SELECT_DATE': 'Seleccione una fecha: ',
      'SAVE': 'Guardar',
      'RECORDATORIOS': 'Recordatorios',
      'RECORDATORIO': 'Recordatorio',
      'ERRORDATE':'La fecha no puede ser menor a la actual.',
      'SAMEDATE':'No está permitido elegir la fecha actual como fecha de lanzamiento de la encuesta',

      'LESSDAYS_T':'¿Seguro que desea continuar?',
      'LESSDAYS_I':'Para que los colaboradores reciban el plan de comunicación completo, es necesario que programe la encuesta con al menos 15 días de anticipación.',
      'CONFLDATE_T':'¡Advertencia!',
      'CONFLDATE_I':'Si continúa no podrá revertir la fecha de lanzamiento. ',
      'WARNING_FECHA_UPDATE':'No se puede seleccionar la fecha actual o una anterior a la fecha actual',
      'FECHA_UPDATE_WARNING':'Esta seguro de modificar la fecha de cierre',
      'FECHA_UPDATE':'La fecha de cierre se actualizó correctamente',



      'FECHA': 'Fecha: ',
      'AGREGAR': 'Agregar',
      'EDITAR': 'Editar',
      'COMPLETAR_PASO': 'Completar paso',
      'PASO_COMPLETADO': 'Paso completado',
      'LOCK':'Reabrir paso',
      'UNLOCK':'Paso en proceso',
      'SUBIRLOGO': 'Para crear su encuesta es necesario subir su logo de empresa',
      'ACEPTARREQUERIMIENTOS': 'Para crear su encuesta es necesario aceptar los requerimientos técnicos',
      'LOGOSSURVEY': 'Para crear su encuesta es necesario primero establecer el o los logotipos necesarios',

      'SELECCIONE_FECHA': 'Por favor, seleccione una fecha',
      'DATE_REGISTERED': 'Fecha de lanzamiento registrada correctamente',
      'CLOSE_REGISTERED': 'Fecha de cierre registrada con éxito',
      'CLOSE_MSJ1': 'la fecha de cierre debe ser mayor que la fecha de lanzamiento',
      'CLOSE_MSJ2': 'Antes de cerrar, debe registrar la fecha de lanzamiento',
      'REMIDEROK': 'Recordatorio registrado correctamente',
      'REMIDERUPDAOK': 'Recordatorio actualizado correctamente',
      'AVIUPDAOK': 'Aviso actualizado correctamente',
      'REMIDER_MSJ1': 'el recordatorio debe ser mayor que la fecha de lanzamiento',
      'REMIDER_MSJ2': 'Antes de registrar un recordatorio, debe registrar la fecha de lanzamiento',
      'ESPERA_ENCUESTA': 'Espere, esto puede tomar unos minutos',
      'ENCUESTA': 'Encuesta',
      'CREANDO_ENCUESTA': 'Creando Encuesta...',
      'AGREGANDO_USUARIOS': 'Agregando usuarios...',
      'AGREGANDO_SECCION1': 'Agregando NPS a la encuesta...',
      'AGREGANDO_SECCION2': 'Agregando REACTIVOS a la encuesta...',
      'AGREGANDO_SECCION3': 'Agregando CONTROL a la encuesta...',
      'AGREGANDO_SECCION4': 'Agregando DEMOGRAFICOS a la encuesta...',
      'AGREGANDO_SECCION5': 'Agregando ADICIONALES a la encuesta...',
      'AGREGANDO_SECCION6': 'Agregando FORALL a la encuesta...',
      'AGREGANDO_SECCION7': 'Agregando Preguntas abiertas a la encuesta...',
      'REINTENTAR': 'Reintentar',
      'ERROR_ENCUESTA': 'Error al crear la encuesta',
      'ERROR_USUARIOS': 'Error al agregar usuarios...',
      'ERROR_SECCION1': 'Error al agregar NPS a la encuesta...',
      'ERROR_SECCION2': 'Error al agregar REACTIVOS a la encuesta...',
      'ERROR_SECCION3': 'Error al agregar CONTROL a la encuesta...',
      'ERROR_SECCION4': 'Error al agregar DEMOGRAFICOS a la encuesta...',
      'ERROR_SECCION5': 'Error al agregar ADICIONALES a la encuesta...',
      'ERROR_SECCION6': 'Error al agregar FORALL a la encuesta...',
      'ERROR_SECCION7': 'Error al agregar Preguntas abiertas a la encuesta...',

      'SUCCESS_ENCUESTA': '¡Encuesta creada correctamente!',
      'SUCCESS_USUARIOS': '¡Usuarios agregados correctamente!',
      'SUCCESS_SECCION1': '¡NPS agregados correctamente a la encuesta!',
      'SUCCESS_SECCION2': '¡REACTIVOS agregados correctamente a la encuesta!',
      'SUCCESS_SECCION3': '¡PREGUNTA DE CONTROL agregada correctamente a la encuesta!',
      'SUCCESS_SECCION4': '¡DEMOGRÁFICOS agregados correctamente a la encuesta!',
      'SUCCESS_SECCION5': '¡ADICIONALES agregados correctamente a la encuesta!',
      'SUCCESS_SECCION6': '¡PRÁCTICAS 4ALL agregadas correctamente a la encuesta!',
      'SUCCESS_SECCION7': 'PREGUNTAS ABIERTAS agregadas correctamente a la encuesta!',
      'BTN_CREARENCUESTA': 'Crear encuesta',

      'CONTINUE_FINISH': 'Encuesta creada correctamente, finalice el paso',
      'LAUNCH_SURVEY': 'Por favor, cree la encuesta para poder finalizar el paso',
      'PULSE':{
        //Shedule survey
        'MES1': ' Pulse Check mes 1',
        'MES2': ' Pulse Check mes 2',
        'MES3': ' Pulse Check mes 3',
        'MES4': ' Pulse Check mes 4',
        'MES5': ' Pulse Check mes 5',
        'MES6': ' Pulse Check mes 6',
        'MES7': ' Pulse Check mes 7',
        'MES8': ' Pulse Check mes 8',
        'MES9': ' Pulse Check mes 9',
        'MES10': ' Pulse Check mes 10',
        'MES11': ' Pulse Check mes 11',
        'MES12': ' Pulse Check mes 12',
        'INDICA': 'Selecciona la fecha de pulse check',
        'INDICA_GENERA':'Generar Encuesta',
        'SUBINDICA_GENERA':'De clic para generar encuesta',


      }
    },
    'SHEDULE2_0': {
      'CARDS': {
        'ERROR':'Los recordatorios no pueden ser antes de la fecha de lanzamiento',
        'PASO1': {
          'TITULO': 'Prerrequisitos',
          'INFO_PRE': 'Necesita cubrir primero estos prerrequisitos antes de crear la encuesta',
          'INFO_POST': 'Ya ha cumplido con los prerrequisitos para crear la encuesta',
          'REQTEC': 'Requerimientos técnicos',
          'REQTEC_TOOLTIP': 'Ir a requerimientos técnicos',
          'LOGO': 'Logotipo de la empresa',
          'LOGO_TOOLTIP': 'Haga clic para cargar el logo',

        },
        'PASO2': {
          'TITULO': 'Fecha de lanzamiento',
          'TITULO_CIERRE': 'Fecha de cierre',
          'INFO_PRE': 'Seleccione y registre la fecha de lanzamiento para la encuesta',
          'INFO_POST': 'Fecha seleccionada',
          'INFO_POST_CIERRE': 'Fecha de Cierre Actual',
          'PICKDATE': 'Abrir calendario',
          'CHANGE': 'Cambiar fecha',
          'LIS-PRORRO':' Prorrogas',
        },
        'PASO2_B': {
          'TITULO': 'Selección de fechas',
          'INFO_PRE': 'Seleccione y registre las diferentes fechas disponibles para configurar la encuesta',
          'PICKDATE': 'Elegir fechas',
          'INFO_PROR': 'Se han asignado prorrogas a este producto',
          'PRORROGAS': 'Ver prorrogas',
          'TIUTLOLISTA': 'Prorrogas creadas',
          'NOPROR': 'No cuenta con prorrogas asignadas'
        },
        'PASO3': {
          'TITULO': 'Recordatorios',
          'INFO_PRE': 'Agregue fechas de envío de recordatorios para contestar la encuesta',
          'INFO_POST': 'Cuenta con dos opciones:',
          'NUEVO': 'Registrar nuevo recordatorio',
          'LISTA': 'Recordatorios registrados',
          'TITU_AVIS':'Avisos',
          'TIUTLOLISTA': 'Recordatorios creados',
          'NORECOS': 'No ha guardado ningún recordatorio',
          'INFOHORA': 'NOTA: Cada recordatorio se muestra en la hora local en: ',
          'LISTA_AVI': 'Comunicación pre encuesta',
          'NOAVI': 'No ha guardado ningún aviso',
          'INFOHORAAVISO': 'NOTA: Cada aviso se muestra en la hora local en: ',
          'TITULOLISTA': 'Avisos creados',
        },
        'PASO4': {
          'TITULO': 'Mensajes de comunicación',
          'INFO_PRE': 'Revise los mensajes de comunicación a enviar durante el ciclo de vida de la encuesta',
          'VERMENSAJES': 'Ver mensajes de comunicación'
        },
        'PASO5': {
          'TITULO': 'Comprobación de la encuesta',
          'TITULO_ALT': 'Comprobación de la Master Table',
          'INFO_PRE': 'Revise las secciones de la encuesta, así como el número de preguntas agregadas en cada sección',
          'VERMENSAJES': 'Ver datos de las secciones',
          'FILTRAR': 'Filtrar secciones por nombre',
          'TABLE':{
            'SECTION': 'Sección',
            'VALUE': 'Valor',
            'INACTIVE':'Inactiva',
            'ACTIVE':'Activa',
            'CLOSE':'Cerrada'
          }
        },
        'PASO6': {
          'TITULO': 'Historial de la generación de la encuesta',
          'INFO_PRE': 'Fecha de la última generación de la encuesta:',
          'INFO_PRE_2': 'Historia de la generación:',
          'ERRORHISTORIAL':'Aún no cuenta con su historial ya que la encuesta no esta creada'
        },
        'PASO7': {
          'TITULO': 'Características de la encuesta',
          'INFO_PRE': 'Antes de configurar las características de la encuesta, es necesario que primero complete los prerrequisitos',
          'INFO_POST_1': 'Antes de crear la encuesta es necesario configurar las características de la encuesta',
          'INFO_POST_2': 'Ya ha establecido la configuración necesaria para crear la encuesta',
          'EMPRESA': 'Logotipo de la empresa',
          'CERTIFICADO': 'Logotipo del certificado',
          'CARACTERISTICAS': 'Características de la encuesta',
          'PREVIEW': 'Vista previa',
          'CAMBIAR': 'Cambiar imagen',
          'LOGO_EMP_INFO': 'La imagen se muestra en su resolución guardada, 200x200 pixeles'
        },
        'MODALGEN': {
          'REGRESAR': 'Regresar',
          'HISTORIAL': {
            'BOTON': 'Historial de generación de la encuesta',
            'TITULO': 'Historial de generación de la encuesta',
            'CARGANDO': 'Cargando historial de generación',
            'ULTIMA': 'Fecha de última generación',
            'ANTERIORES': 'Fechas de generación anteriores',
            'NOHISTO': 'No se cuenta con el historial de generación de la encuesta'
          },
          'CERTIFICADO': {
            'TITULO': 'Vista previa del certificado'
          },
          'URL_QR': {
            'BOTON': 'Obtener enlace en código QR',
            'TITULO': 'Enlace de la encuesta en código QR',
            'SUBTITULO': 'Al escanear este código QR puede acceder directamente a la encuesta sin tener que ingresar el enlace manualmente',
            'DESCARGA': 'Para descargar el código QR, haga clic derecho sobre la imagen y después en la opción <b><em>Guardar imagen como...</em></b>',
            'REGENERARQR': 'La URL fue modificada correctamente, si cuenta con un código QR de la URL anterior, es necesario que obtenga un nuevo código QR con el enlace actualizado'
          }
        },
        'STATUS': {
          'PENDING': 'Aún no completo',
          'OK': 'Listo',
          'OPT': 'Este paso es opcional'
        },
        'FECHAS': {
          'TITULO': 'Selección de fechas',
          'FECHA': 'Fecha seleccionada: ',
          'NOTYET': 'Aún no elegida',
          'INFO': {
            '1': 'Seleccione cada una de las fechas disponibles para configurar la encuesta.',
            '2': 'NOTA: La hora seleccionada en cada fecha está establecida en la hora local en: '
          },
          'TABLA': {
            'TIPO': 'Tipo de fecha',
            'FECHA': 'Fecha seleccionada',
            'ACCIONES': 'Acciones'
          },
          'TIPOS': {
            'lanzamiento': 'Fecha de lanzamiento',
            'aviso1': 'Pre-lanzamiento (Primer aviso antes del lanzamiento de la encuesta)',
            'aviso2': 'Pre-lanzamiento (Segundo aviso antes del lanzamiento de la encuesta)',
            'cierre': 'Fecha de cierre',
            'recor30': 'Pre-lanzamiento (Aviso 30 días antes de la encuesta)',
            'recor29': 'Pre-lanzamiento (Aviso 29 días antes de la encuesta)',
            'recor15': 'Pre-lanzamiento (Aviso 15 días antes de la encuesta)',
            'recor7': 'Pre-lanzamiento (Aviso 7 días antes de la encuesta)',
            'result': 'Resultados:',
          },
          'BOTONES': {
            'ELEGIR': 'Elegir fecha',
            'CAMBIAR': 'Cambiar fecha',
            'CANCELAR': 'Cancelar',
            'ACEPTAR': 'Aceptar',
            'ENVIOCIERRE': 'Envíar notificación'
          }
        }
      },
      'CREAR': 'Crear encuesta',
      'RECREAR': 'Volver a crear encuesta',
      'ENCUESTACREADA': 'Encuesta creada',
      'ENCUESTAERROR': 'La encuesta no se creó de forma correcta',
      'VERSECCIONES': 'Ver secciones agregadas',
      'BACK': 'Regresar',
      'CERRAR': 'Cerrar',
      'CREANDO': 'La encuesta se está creando, espere hasta que cada una de sus componentes sea agregado correctamente',
      'RETRY': 'Reintentar el proceso',
      'SECCIONES': {
        'DETALLES': 'Guardando ultimos detalles',
        'COMPLETA': '¡La encuesta se creó correctamente!',
        'ENCUESTA': {
          'TITULO': 'Encuesta',
          'PROCESO': 'Creando encuesta',
          'ERROR': 'Ocurrió un error al crear la encuesta, vuelva a intentar el proceso'
        },
        'USUARIOS': {
          'TITULO': 'Usuarios',
          'PROCESO': 'Agregando usuarios a la encuesta',
          'ERROR': 'Ocurrió un error al agregar los usuarios, vuelva a intentar el proceso',
        },
        'NPS': {
          'TITULO': 'NPS',
          'PROCESO': 'Agregando NPS a la encuesta',
          'ERROR': 'Ocurrió un error al agregar NPS, vuelva a intentar el proceso',
        },
        'REACTIVOS': {
          'TITULO': 'Reactivos',
          'PROCESO': 'Agregando reactivos a la encuesta',
          'ERROR': 'Ocurrió un error al agregar los reactivos, vuelva a intentar el proceso',
        },
        'CONTROL': {
          'TITULO': 'Pregunta de control',
          'PROCESO': 'Agregando pregunta de control a la encuesta',
          'ERROR': 'Ocurrió un error al agregar la pregunta de control, vuelva a intentar el proceso',
        },
        'DEMOGRAFICOS': {
          'TITULO': 'Demográficos',
          'PROCESO': 'Agregando demográficos a la encuesta',
          'ERROR': 'Ocurrió un error al agregar los demográficos, vuelva a intentar el proceso',
        },
        'ABIERTAS': {
          'TITULO': 'Preguntas abiertas',
          'PROCESO': 'Agregando preguntas abiertas a la encuesta',
          'ERROR': 'Ocurrió un error al agregar las preguntas abiertas, vuelva a intentar el proceso',
        },
        'FORALL': {
          'TITULO': 'ForAll',
          'PROCESO': 'Agregando prácticas ForAll a la encuesta',
          'ERROR': 'Ocurrió un error al agregar las prácticas ForAll, vuelva a intentar el proceso',
        },
        'ADICIONALES': {
          'TITULO': 'Adicionales',
          'PROCESO': 'Agregando preguntas adicionales a la encuesta',
          'ERROR': 'Ocurrió un error al agregar las preguntas adicionales, vuelva a intentar el proceso',
        },
        'ADICIONALES-FOCUS': {
          'TITULO': 'Personalizadas',
          'PROCESO': 'Agregando preguntas personalizadas a la encuesta',
          'ERROR': 'Ocurrió un error al agregar las preguntas personalizadas, vuelva a intentar el proceso',
        },
      },
      'MODALES': {
        'ENCUESTA': {
          'CREAR_1': '¿Desea crear la encuesta con la configuración actual?',
          'CREAR_2': 'Una vez creada la encuesta, no podrá modificar los mensajes de comunicación',
          'CREAR_3': '¿Desea iniciar la creación de la encuesta?',
          'SINFECHA': 'Para crear la encuesta es necesario que primero elija la fecha de lanzamiento de la misma',
          'CREADA_1': '¡La encuesta se creó correctamente!',
          'CREADA_2': 'Ahora puede completar esta sección y continuar con la siguiente',
          'RECOEXIS': 'Ya hay un recordatorio registrado para el dia seleccionado',
          'RECOBEFORE': 'No puede registrar un recordatorio sin antes haber elegido la fecha de lanzamiento de la encuesta',
          'RECOMAX': 'Ya ha programado todos los recordatorios permitidos, ya no puede registrar más',
          'LASTRECO_1': 'Aviso:',
          'LASTRECO_2': 'Ha programado todos los recordatorios permitidos, ya no podrá registrar más',
          'LISTARECOBEF': 'No puede ver la lista de recordatorios sin antes haber elegido la fecha de lanzamiento de la encuesta',
          'FINAL': 'Ahora puede completar esta sección y continuar con la siguiente',
          'SAVELAUNCHDATE': 'Guardando la fecha de lanzamiento, espere por favor',
          'SAVEAVISODATE': 'Guardando la fecha de aviso, espere por favor',
          'AVISOOK': 'Fecha de aviso registrada correctamente',
          'CHANGELAUNCH': 'Advertencia: Si cambia la fecha de lanzamiento de la encuesta, se borrará el resto de las fechas y tendrá que seleciconarlas nuevamente, ¿desea elegir otra fecha de lanzamiento?',
          'CHANGECLOSENOT': 'Se cambió el estado del envío correctamente',
          'GUARDANDO_LOGO': 'Guardando imagen, espere un momento',
          'CARGA_CERT': 'Para obtener la máxima calidad en el documento final, asegúrese de cargar una imagen con resolución mínima de 400 x 240 pixeles',
          'BORRA_RECO_1': '¿Está seguro de borrar el recordatorio con la siguiente fecha?',
          'BORRA_RECO_2': 'El recordatorio fue borrado correctamente',
          'BORRA_AVI_1': '¿Está seguro de borrar el aviso con la siguiente fecha?',
          'BORRA_AVI_2': 'El aviso fue borrado correctamente',
          'UPDA_AVISO':'Actualizando fecha aviso',
          'UPDA_RECOR':'Actualizando fecha recordatorio',
          'DELE_AVISO':'Eliminando fecha aviso',
          'DELE_RECOR':'Eliminando fecha recordatorio',
          'GUARD_RECOR':'Guardando fecha recordatorio',
          'TITL_MOD_QUES_ALEAT':'Para crear la encuesta es necesario habilitar la validación de la pregunta aleatoria',
          'TEXT_MOD_QUES_ALEAT_1':'A continuación siga estos pasos:',
          'TEXT_MOD_QUES_ALEAT_2':'1.- Ingresar en editar las características de la encuesta',
          'TEXT_MOD_QUES_ALEAT_3':'2.- Dar click en configuración adicional y habilitar la validación de la pregunta aleatoria',
        }
      },
      'CORREOS': {
        'VER': 'Ver mensaje',
        'TIPO1': {
            'TITULO': 'Mensaje previo al lanzamiento',
            'INFO': 'Estos son los mensajes enviados días antes del lanzamiento de la encuesta',
            'TIPO_1': 'Primer aviso',
            'TIPO_2': 'Segundo aviso',
        },
        'TIPO2': {
            'TITULO': 'Mensaje de invitación',
            'INFO': 'Este es el mensaje enviado a los colaboradores el día de lanzamiento de la encuesta'
        },
        'TIPO3': {
            'TITULO': 'Mensaje de recordatorio',
            'INFO': 'Este es el mensaje de recordatorio enviado en los dias programados para este fin'
        },
        'TIPO4': {
            'TITULO': 'Mensaje de primer aviso',
            'INFO': ''
        },
        'TIPO5': {
            'TITULO': 'Mensaje de segundo aviso',
            'INFO': ''
        },
        'TIPO6': {
            'TITULO': 'Mensaje de cierre',
            'INFO': 'Este es el mensaje enviado a los colaboradores en la fecha de cierre de la encuesta.\nNOTA: sólo se enviará si ha sido activado'
        },
        'TIPO7': {
          'TITULO': 'Mensaje a colaboradores que no han iniciando su encuesta',
          'INFO': 'Este es el mensaje de recordatorio enviado a los colaboradores que aún no inician su encuesta'
        },
        'TIPO8': {
          'TITULO': 'Mensaje a los colaboradores que aún no han terminado.',
          'INFO': 'Este es el mensaje de recordatorio enviado a los colaboradores que ya han empezado su encuesta pero aún no terminan'
        },
      },
      'EDITOR': {
        'BOTONES': {
          'INFO': 'Información importante',
          'SAVE': 'Guardar los cambios',
          'EDIT': 'Editar el mensaje',
        },
        'PENDING': 'En proceso de validación',
        'MODALINFO': {
          'TITULO': 'Información importante sobre el contenido del correo',
          'PARTE_1': 'Para que el correo sea considerado correcto para ser enviado, en el cuerpo del mensaje se pueden incluir las siguientes etiquetas (Atención, las etiquetas obligatorias deben ser incluídas al menos una vez):',
          'PARTE_2': 'La razón de esto, es debido a que al llegar la fecha del envío de cada correo, la plataforma realiza los siguientes reemplazos en el mensaje de manera automática:',
          'tag_company': 'El nombre de la empresa',
          'tag_link': 'El enlace de acceso a la encuesta',
          'tag_date': 'La fecha de lanzamiento de la encuesta',
          'tag_user': 'Contraseña de acceso a la encuesta',
          'tag_dtb': 'Días para el comienzo de la encuesta (a partir de la fecha de envío del mensaje)',
          'tag_dtc': 'Días para el fin de la encuesta (a partir de la fecha de envío del mensaje)',
          'tag_end': 'La fecha del cierre de la encuesta',
          'tag_userAction': 'Usuario para ingresar ',
          'tag_pass': 'La contraseña del usuario',
          'tag_linkAction': 'El enlace de acceso a cultrural Go',
          'PARTE_3': 'Las etiquetas pueden colocarse en cualquier lugar del cuerpo del correo. Una vez que las etiquetas estén presentes en el contenido, este podrá ser guardado.',
          'PARTE_4': 'Nota: es posible que el mensaje requiera ser validado por un jefe de proyecto, si es el caso, podrá ver el estado de validación del nuevo correo en esta pantalla. Durante el proceso de validación no podrá realizar una nueva edición del correo. En caso contrario, el correo será considerado válido de manera inmediata y podrá realizar nuevamente edición al mismo si así lo desea.',
          'OPC': '(Opcional)',
          'MDT': '(Obligatorio, excepto en el mensaje de cierre)'
        },
        'MODALES': {
          'SINCAMBIOS': 'Aún no ha realizado cambios al contenido del correo',
          'SINTAG': 'No se puede guardar el correo, no se encontró la etiqueta ',
          'GUARDAR_1': '¿Desea guardar los cambios realizados al mensaje?',
          'GUARDAR_2': 'Le recordamos que será enviado a validación y no podrá reeditarlo hasta que el proceso de validación termine',
          'SAVEOK_1': 'El contenido del correo se guardó correctamente',
          'SAVEOK_2': 'Espere a que un jefe de proyecto valide las modificaciones',
          'ENABLED': 'Un jefe de proyecto ha activado la edición del correo electrónico, puede continuar realizando modificaciones',
          'CAMBIOIDIOMA_1': 'Atención: si desea elegir otro idioma, los cambios realizados hasta el momento en el idioma actual deben ser guardados primero',
          'CAMBIOIDIOMA_2': '¿Desea guardar los cambios y elegir otro idioma?',
        }
      },
      'ZONAS': {
        '1': 'Ciudad de México',
        '2': 'San Salvador',
        '3': 'Hong Kong',
        '4': 'Singapur',
        '5': 'Estambul',
        '6': 'Manila',
        '11': 'Brasilia',
        '15': 'Madrid',
        '18': 'Ciudad de México',
      },
      'SECCIONES_ESPECIALES': {
        'TITULO': 'Esta encuesta cuenta con secciones especiales',
        'SUBTITULO': 'A continuación se muestran los usuarios demo de manera agrupada, cada grupo está destinado para realizar la prueba a la encuesta con cada sección especial por separado, o a la encuesta sin secciones especiales',
        'ELEGIR': 'Seleccione un grupo del menú de la izquierda',
        'LISTA': {
          'TITULO': 'Secciones especiales',
          'SIN_SECCION': 'Encuesta sin secciones especiales'
        }
      },
      'CORREOS_NORM':{
        'TIPO1':{
          'TITULO': 'Mensaje de invitación',
          'INFO': 'Este es el mensaje enviado a los colaboradores el día de lanzamiento de la encuesta'
        },
        'TIPO2':{
          'TITULO': 'Mensaje de aviso: 30 dias previo a lanzamientode invitación' ,
          'INFO': 'Estos son los mensajes enviados días antes del lanzamiento de la encuesta'
        },
        'TIPO3':{
          'TITULO': 'Mensaje de aviso: 29 dias previo a lanzamientode invitación',
          'INFO': 'Estos son los mensajes enviados días antes del lanzamiento de la encuesta'
        },
        'TIPO4':{
          'TITULO': 'Mensaje de aviso: 15 dias previo a lanzamientode invitación',
          'INFO': 'Estos son los mensajes enviados días antes del lanzamiento de la encuesta'
        },
        'TIPO5':{
          'TITULO': 'Mensaje de aviso: 7 dias previo a lanzamientode invitación',
          'INFO': 'Estos son los mensajes enviados días antes del lanzamiento de la encuesta'
        },
        'TIPO6':{
          'TITULO': 'Mensaje de cierre',
          'INFO': 'Este es el mensaje enviado a los colaboradores en la fecha de cierre de la encuesta.\nNOTA: sólo se enviará si ha sido activado'
        },
        'TIPO7':{
          'TITULO': 'Mensaje de recordatorio',
          'INFO': 'Este es el mensaje de recordatorio enviado en los dias programados para este fin'
        },
      }
    }
  }
};
